proj4.defs([
    ['EPSG:4326', '+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees'],
    ['EPSG:3826', '+title=TWD97 TM2+proj=tmerc +lat_0=0 +lon_0=121 +k=0.9999 +x_0=250000 +y_0=0 +ellps=GRS80 +units=公尺 +no_defs']
])
var EPSG3826 = new proj4.Proj('EPSG:3826'),
    EPSG4326 = new proj4.Proj('EPSG:4326')

// basemap setting
var nlscmaps = [
    new L.NLSC.EMAP2({opacity: 0.6}),
    new L.NLSC.LANDSECT({opacity: 0.7}),
    new L.NLSC.Village({opacity: 0.7}),
    new L.NLSC.LUIMAP({opacity: 0.7}),
	new L.NLSC.TOWN({opacity: 0.7})
]

var baseMaps = {}
baseMaps["通用版電子地圖"] = new L.NLSC.EMAP({opacity: 1});
baseMaps["正射影像圖"] = new L.NLSC.PHOTO2({opacity: 1});
baseMaps["Google街道"] = new L.tileLayer('https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i{z}!2i{x}!3i{y}!4i256!2m3!1e0!2sm!3i349018013!3m9!2sen-US!3sUS!5e18!12m1!1e47!12m3!1e37!2m1!1ssmartmaps!4e0',{
	maxZoom: 22,
	opacity: 1
})
baseMaps["Google地形"] = new L.tileLayer('https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',{
    maxZoom: 22,
    subdomains:['mt0','mt1','mt2','mt3'],
    opacity: 1
})
baseMaps["Google灰階街道"] = new L.tileLayer('https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i{z}!2i{x}!3i{y}!4i256!2m3!1e0!2sm!3i432136532!3m14!2szh-TW!3sUS!5e18!12m1!1e68!12m3!1e37!2m1!1ssmartmaps!12m4!1e26!2m2!1sstyles!2sp.s%3A-100!4e0!23i1301875',{
	maxZoom: 22,
	opacity: 1
})
baseMaps["Google黑階街道"] = new L.tileLayer('https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i{z}!2i{x}!3i{y}!4i256!2m3!1e0!2sm!3i480190100!3m14!2szh-TW!3sUS!5e18!12m1!1e68!12m3!1e37!2m1!1ssmartmaps!12m4!1e26!2m2!1sstyles!2zcy5lOmd8cC5jOiNmZjI0MmYzZSxzLmU6bC50LnN8cC5jOiNmZjI0MmYzZSxzLmU6bC50LmZ8cC5jOiNmZjc0Njg1NSxzLnQ6MTl8cy5lOmwudC5mfHAuYzojZmZkNTk1NjMscy50OjJ8cy5lOmwudC5mfHAuYzojZmZkNTk1NjMscy50OjQwfHMuZTpnfHAuYzojZmYyNjNjM2Yscy50OjQwfHMuZTpsLnQuZnxwLmM6I2ZmNmI5YTc2LHMudDozfHMuZTpnfHAuYzojZmYzODQxNGUscy50OjN8cy5lOmcuc3xwLmM6I2ZmMjEyYTM3LHMudDozfHMuZTpsLnQuZnxwLmM6I2ZmOWNhNWIzLHMudDo0OXxzLmU6Z3xwLmM6I2ZmNzQ2ODU1LHMudDo0OXxzLmU6Zy5zfHAuYzojZmYxZjI4MzUscy50OjQ5fHMuZTpsLnQuZnxwLmM6I2ZmZjNkMTljLHMudDo0fHMuZTpnfHAuYzojZmYyZjM5NDgscy50OjY2fHMuZTpsLnQuZnxwLmM6I2ZmZDU5NTYzLHMudDo2fHMuZTpnfHAuYzojZmYxNzI2M2Mscy50OjZ8cy5lOmwudC5mfHAuYzojZmY1MTVjNmQscy50OjZ8cy5lOmwudC5zfHAuYzojZmYxNzI2M2M!4e0!5m1!5f2',{
	maxZoom: 22,
	opacity: 1
})
baseMaps["Google衛星"] = new L.tileLayer('https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',{
    maxZoom: 22,
    subdomains:['mt0','mt1','mt2','mt3'],
    opacity: 1
})
baseMaps["Google混合"] = new L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',{
    maxZoom: 22,
    subdomains:['mt0','mt1','mt2','mt3'],
    opacity: 1
})
baseMaps["Google混合未透明"] = new L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',{
    maxZoom: 22,
    subdomains:['mt0','mt1','mt2','mt3']
})
baseMaps["ESRI衛照"] = new L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
    maxZoom: 18
})
baseMaps["OSM"] = new L.tileLayer('//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png');
// baseMaps["灰階OSM"] = new L.tileLayer('https://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png');
baseMaps["地形OSM"] = new L.tileLayer('//{s}.tile.opentopomap.org/{z}/{x}/{y}.png');

var overlayMaps = {};
overlayMaps['日累積降雨'] = L.imageOverlay("https://alerts.ncdr.nat.gov.tw/DownLoadNewAssistData.ashx/9", [[21.8682756536471, 120.016611031922], [25.3343309654311, 122.034749689268]], {opacity: 0.7});
overlayMaps['雷達迴波'] = L.imageOverlay("https://alerts.ncdr.nat.gov.tw/DownLoadNewAssistData.ashx/8", [[19.1921270314352, 114.996294366279], [27.2037071362372, 129.225927854919]], {opacity: 0.7});
overlayMaps['衛星雲圖'] = L.imageOverlay("https://opendata.cwa.gov.tw/fileapi/opendata/MSC/O-C0042-002.jpg", [[19.100625745, 115.976888855], [28.29937425, 126.02300114]], {opacity: 0.7});
overlayMaps["新北市行政範圍"] = L.tileLayer.wms(publicPath + '/cloud/geoserver/taiwan/wms?',{
	layers: 'taiwan:ntc_mask',
	transparent: true,
	format: 'image/png',
	maxZoom: 22,
	opacity: 0.5
})
overlayMaps["新北市村里界"] = L.WMS.overlay(publicPath + '/cloud/geoserver/taiwan/wms?',{
	layers: 'taiwan:village_w84',
	transparent: true,
	format: 'image/png',
	maxZoom: 22,
	cql_filter: "COUNTYNAME = '新北市' and VILLNAME <> ''"
})
var ntpc_subdist = ajax_call(publicPath + '/cloud/geoserver/taiwan/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=taiwan%3Antc_subdist&outputFormat=application%2Fjson'),
	ntpcSubdistExceptHandleList = ["確診者點位圖X", "確診者足跡點位圖Y", "NX+MY混和熱度圖"]
overlayMaps["新北市次分區"] = L.geoJSON(ntpc_subdist, {
	style: function(feature){
		var color
		if (feature.properties.ntownname === "板橋區") {
			color = 'blue'
		} else if (feature.properties.ntownname === "中和區") {
			color = 'purple'
		} else if (feature.properties.ntownname === "淡水區") {
			color = '#00FFFF'
		} else if (feature.properties.ntownname === "五股區") {
			color = '#AD5A5A'
		} else if (feature.properties.ntownname === "蘆洲區") {
			color = '#5B5B00'
		} else if (feature.properties.ntownname === "三重區") {
			color = '#02C874'
		} else if (feature.properties.ntownname === "新莊區") {
			color = '#FF5809'
		} else if (feature.properties.ntownname === "樹林區") {
			color = '#28FF28'
		} else if (feature.properties.ntownname === "土城區") {
			color = '#F9F900'
		} else if (feature.properties.ntownname === "新店區") {
			color = 'black'
		} else if (feature.properties.ntownname === "永和區") {
			color = '#00E3E3'
		} else if (feature.properties.ntownname === "汐止區") {
			color = '#F046AA'
		} else if (feature.properties.ntownname === "三峽區") {
			color = '#0D47A1'
		} else if (feature.properties.ntownname === "泰山區") {
			color = '#F59C31'
		} else if (feature.properties.ntownname === "林口區") {
			color = '#B51E58'
		} else {
			color = '#814B12'
		}
		return { fillColor: color, weight: 2, color: 'white', opacity: 1, fillOpacity: 0.3 }
	},
	onEachFeature: function(feature, layer){
		layer.bindTooltip(feature.properties.ntownname + feature.properties.subdist, {
			sticky: true,
			opacity: 0.8
		})
	}
})
overlayMaps['新北市次分區'].on("add",function(){
	ntpcSubdistExceptHandleList.forEach(el => {
		if (map.hasLayer(overlay_dataset[el])) {
			map.removeLayer(overlay_dataset[el])
			map.addLayer(overlay_dataset[el])
		}
	})
});
var overlay_dataset = {}
overlay_dataset["Basic_map"] = NTC_map()
overlayMaps["新北市行政區"] = L.geoJSON(overlay_dataset['Basic_map'], {
	style: function(feature){
		return {
			color: "grey",
			weight: 2,
			fillOpacity: 0
		}
	}
})

for (var i in nlscmaps) {
    overlayMaps[nlscmaps[i].name] = nlscmaps[i];
}

var baseTree = [{
    label: '✦主要底圖',
    children: [
    	{label: '通用版電子地圖', layer: baseMaps["通用版電子地圖"]},
    	{label: '正射影像圖', layer: baseMaps["正射影像圖"]},
    	{label: 'ESRI衛照', layer: baseMaps["ESRI衛照"]},
    	{label: 'Google街道', layer: baseMaps["Google街道"]},
    	{label: 'Google地形', layer: baseMaps["Google地形"]},
    	{label: 'Google灰階街道', layer: baseMaps["Google灰階街道"]},
    	{label: 'Google黑階街道', layer: baseMaps["Google黑階街道"]},
    	{label: 'Google衛星', layer: baseMaps["Google衛星"]},
    	{label: 'Google混合', layer: baseMaps["Google混合"]},
    	{label: 'Google混合未透明', layer: baseMaps["Google混合未透明"]},
        {label: 'OpenStreeMap', layer: baseMaps["OSM"]},
        // {label: '灰階OSM', layer: baseMaps["灰階OSM"]},
        {label: 'OpenTopoMap', layer: baseMaps["地形OSM"]},
    ]
}]

var overlaysTree = [{
    label: '✦套疊底圖-透明底圖',
    children: [
			{label: '新北市行政區', layer: overlayMaps['新北市行政區']},
			{label: '透明電子地圖', layer: overlayMaps['通用版電子地圖透明']},
			{label: '新北市次分區', layer: overlayMaps['新北市次分區']},
			{label: '新北市村里界', layer: overlayMaps['新北市村里界']},
			{label: '鄉區界', layer: overlayMaps['鄉區界']},
			{label: '村里界', layer: overlayMaps['村里界']},
			{label: '段籍圖', layer: overlayMaps['段籍圖']},
			{label: '國土利用調查成果', layer: overlayMaps['國土利用調查成果圖']},
			{label: '新北市行政範圍', layer: overlayMaps['新北市行政範圍']}
		]
	}, {
		label: '✦套疊底圖-水保署事件衛星影像',
		children: [
			{label: '20220323_地震', layer: new L.tileLayer('https://storage.geodac.tw/Tile/RSImage/Satellite/Sentinel2/20220425_121004092_023449029_07_000_RSImage_Satellite_Sentinel2/{z}/{y}/{x}.jpg')},
			{label: '20210911_璨樹颱風', layer: new L.tileLayer('https://storage.geodac.tw/Tile/RSImage/Satellite/Sentinel2/20210922_121004092_023449029_07_000_RSImage_Satellite_Sentinel2/{z}/{y}/{x}.jpg')},
			{label: '20210722_烟花颱風', layer: new L.tileLayer('https://storage.geodac.tw/Tile/RSImage/Satellite/Sentinel2/20210823_121004092_023449029_07_000_RSImage_Satellite_Sentinel2/{z}/{y}/{x}.jpg')},
			{label: '20210621_豪雨事件', layer: new L.tileLayer('https://storage.geodac.tw/Tile/RSImage/Satellite/Sentinel2/20210709_121004092_023449029_07_000_RSImage_Satellite_Sentinel2/{z}/{y}/{x}.jpg')},
			{label: '20190808_利奇馬颱風', layer: new L.tileLayer('https://storage.geodac.tw/Tile/RSImage/Satellite/Sentinel2/20190913_121004092_023449029_07_000_RSImage_Satellite_Sentinel2/{z}/{y}/{x}.jpg')}
		]
	}]

// set up the map
var map = new L.Map('map', {
    preferCanvas: true,
    attributionControl: false,
    zoomControl: false,
    center: new L.LatLng(25.038169, 121.557588),
    zoom: 11,
    zoomSnap: 1,
    layers: [baseMaps["Google地形"], overlayMaps["新北市行政區"]],
    renderer: L.canvas({ padding: 0.5, tolerance: 10 })
})

map.createPane("high-zindex-wms-layer")
$(".leaflet-pane .leaflet-high-zindex-wms-layer-pane").addClass("z-550")

overlayMaps["火災熱區-住警器"] = L.tileLayer.wms(publicPath + '/cloud/geoserver/edp3/wms?',{
	layers: 'edp3:ntc_20m_fire_show_84',
	transparent: true,
	format: 'image/png',
	maxZoom: 22,
	pane: "high-zindex-wms-layer"
})

L.control.scale({
	position:'bottomright',
	maxWidth: 50
}).addTo(map)

var layer_box = L.control.layers.tree(baseTree, overlaysTree,{
    position:'bottomright'
}).addTo(map)

function wmsTileLayerCreate(url, option){
    var setting= {
			layers: option.layer,
			transparent: true,
			format: 'image/png',
			maxZoom: 22,
			pane: option.pane
		},
		thisLayer
	if (option.style) {
		setting.styles = option.style
	}
	if (option.filter) {
		setting.cql_filter = option.filter
	}
	thisLayer = L.tileLayer.wms(url, setting)
    wmsQueryTargetList.push({url: url, option: option})
    return thisLayer
}

function event_raw_geojson(data, project_id_query, project_id_type){
	var result = null;
	var disa_level_class = ["1", "9"];
	var geojson_data = [
		{type: "FeatureCollection", features: []},
		{type: "FeatureCollection", features: []}
	];
	for (var i = 0; i < 2; i++) {
		data[i].forEach(function(element){
			geojson_data[i].features.push({
				"type": "Feature",
				"geometry": {
			      	"type": "Point",
			      	"coordinates": [element.WGS_X, element.WGS_Y]
				},
				"properties": {
					"TID": element.TID,
					"DISA_TYPE": element.DISA_TYPE,
					"DISA_LEVEL": disa_level_class[i],
					"STATUS": element.STATUS,
					"WGS_X": element.WGS_X,
					"WGS_Y": element.WGS_Y,
					"PRJ_ID": element.PRJ_ID,
					"DISA_NO": element.DISA_NO,
					"RPT_TIME": element.RPT_TIME,
					"DISA_LOCATION": element.DISA_LOCATION,
					"TrafficImpact": element.TrafficImpact,
					"project_id_type": project_id_type
				}
			})
		})
	};
	result = geojson_data;
	return result;
}

function event_marker(geojson_data, filter_condition, filter_time, map_type){
	var result = [], filter_method = null;
	switch(true){
		case(filter_condition == 'skip'):
			break
		case(filter_condition == null):
			event_sta(geojson_data);
			break;
		case(filter_condition != null):
			if (filter_condition.key.length !== 0) {
				filter_method = filter;
			} else {
				filter_method = filter_time_only;
			}
			break;
		case(filter_time != null):
			filter_method = filter_time_only;
			break;
	}

	var impact_Icon = {
	    iconUrl: '',
	    iconAnchor:   [15, 32],
	    iconSize:     [32, 32],
	    popupAnchor:  [0, -20],
	    shadowUrl: 'marker_icon/marker_shadow.png',
	    shadowSize:   [48, 40],
	    shadowAnchor: [24, 24],
	}

	var imapct_event_Layer = L.geoJson(geojson_data[1], {
		filter: filter_method,
	  	pointToLayer: function(feature, latlng) {
	    	if(feature.properties.STATUS == "05"){
	    		impact_Icon["iconUrl"] = 'marker_icon/event_serious_slove_new2.png';
	    	} else{
	    		impact_Icon["iconUrl"] = 'marker_icon/event_serious_new2.png';
	    	}
	    	return L.marker(latlng, {
	      		icon: new L.icon(impact_Icon)
	    	}).bindPopup('<div id="event_div">資料連結中...</div><div id="event_div_chart"></div>');
	  	}
	});

 	// cluster processing
 	// normal event
	switch(map_type){
		case "cluster":
			var normal_Icon_slove = { html: '<div><span>1</span></div>', className: 'marker-cluster' + ' marker-cluster-small', iconSize: new L.Point(30, 30) };
			var normal_Icon_unslove = { html: '<div><span>1</span></div>', className: 'marker-cluster' + ' marker-cluster-small_red', iconSize: new L.Point(30, 30) };
			var raw_event_Layer = L.geoJson(geojson_data[0], {
				filter: filter_method,
			  	pointToLayer: function(feature, latlng) {
			    	if(feature.properties.STATUS == "05"){
				    	return L.marker(latlng, {
				      		icon: new L.DivIcon(normal_Icon_slove)
				    	}).bindPopup('<div id="event_div">資料連結中...</div><div id="event_div_chart"></div>');
			    	}
			  	}
			})
			var raw_event_Layer_unslove = L.geoJson(geojson_data[0], {
				filter: filter_method,
			  	pointToLayer: function(feature, latlng) {
			    	if(feature.properties.STATUS != "05"){
				    	return L.marker(latlng, {
				      		icon: new L.DivIcon(normal_Icon_unslove)
				    	}).bindPopup('<div id="event_div">資料連結中...</div><div id="event_div_chart"></div>');
			    	}
			  	}
			})
			var event_layer = L.markerClusterGroup();
			event_layer.addLayer(raw_event_Layer);
			var event_layer_unslove = L.markerClusterGroup_RED();
			event_layer_unslove.addLayer(raw_event_Layer_unslove);
			var event_layer_all = L.layerGroup([event_layer, event_layer_unslove]);
			break;
		case "heatmap":
			var event_array = {max:4, data:[]};
			var raw_event_Layer_all = L.geoJson(geojson_data[0], {
				filter: filter_method
			});
			for (var element in raw_event_Layer_all._layers) {
				event_array.data.push({lat: parseFloat(raw_event_Layer_all._layers[element].feature.geometry.coordinates[1]), lng: parseFloat(raw_event_Layer_all._layers[element].feature.geometry.coordinates[0]), count: 1});
			}
			var cfg = {
				// radius should be small ONLY if scaleRadius is true (or small radius is intended)
				// if scaleRadius is false it will be the constant radius used in pixels
				"radius": 0.004,
				"maxOpacity": .8,
				// scales the radius based on map zoom
				"scaleRadius": true,
				// if set to false the heatmap uses the global maximum for colorization
				// if activated: uses the data maximum within the current map boundaries
				//   (there will always be a red spot with useLocalExtremas true)
				"useLocalExtrema": false,
				latField: 'lat',
				lngField: 'lng',
				valueField: 'count'
			};
			var event_layer_all = new HeatmapOverlay(cfg);
			event_layer_all.setData(event_array);
			break;
		case "normal":
			var normal_Icon_slove = { html: '<div><span>1</span></div>', className: 'marker-cluster' + ' marker-cluster-small', iconSize: new L.Point(15, 15) };
			var normal_Icon_unslove = { html: '<div><span>1</span></div>', className: 'marker-cluster' + ' marker-cluster-small_red', iconSize: new L.Point(15, 15) };
			var raw_event_Layer = L.geoJson(geojson_data[0], {
				filter: filter_method,
			  	pointToLayer: function(feature, latlng) {
			    	if(feature.properties.STATUS == "05"){
				    	return L.circleMarker(latlng, {
				      		radius: 7,
				      		fillOpacity: 1,
				      		fillColor: '#3ac569',
				      		color: 'black',
				      		weight: 1
				    	}).bindPopup('<div id="event_div">資料連結中...</div><div id="event_div_chart"></div>');
			    	}
			  	}
			})
			var raw_event_Layer_unslove = L.geoJson(geojson_data[0], {
				filter: filter_method,
			  	pointToLayer: function(feature, latlng) {
			    	if(feature.properties.STATUS != "05"){
				    	return L.circleMarker(latlng, {
				      		radius: 7,
				      		fillOpacity: 1,
				      		fillColor: '#e85a71',
				      		color: 'black',
				      		weight: 1
				    	}).bindPopup('<div id="event_div">資料連結中...</div><div id="event_div_chart"></div>');
			    	}
			  	}
			})
			var event_layer = L.markerClusterGroup({
				maxClusterRadius: 0.0000001
			});
			event_layer.addLayer(raw_event_Layer);
			var event_layer_unslove = L.markerClusterGroup_RED({
				maxClusterRadius: 0.0000001
			});
			event_layer_unslove.addLayer(raw_event_Layer_unslove);
			var event_layer_all = L.layerGroup([event_layer, event_layer_unslove]);
	}
	leafletExtendTileHandle()
	var serious_event_render = $(".scale_target").eq(0).find("input").prop('checked');
	var normal_event_render = $(".scale_target").eq(1).find("input").prop('checked');
	if (serious_event_render) {
		map.addLayer(imapct_event_Layer);
	}
	if (normal_event_render) {
		map.addLayer(event_layer_all);
	}

	result = [imapct_event_Layer, event_layer_all];

 	// impact event
 	if (map_type != "heatmap") {
 		try {
 			raw_event_Layer.on('click', onClick);
			raw_event_Layer_unslove.on('click', onClick);
 		} catch(e){
 			alert("災情點位點擊事件綁定失敗!")
 		}
 	}
 	imapct_event_Layer.on('click', onClick);

	function onClick(e) {
		map.setView([e.latlng.lat, e.latlng.lng]);
		var this_marker = e.layer;
		var trigger_method;
		isiOS ? ( (trigger_method = "mouseover") ) : ( (trigger_method = "click"));
		setTimeout(function(){
			map.panBy([-180, -180]);
			var url = publicPath + '/napi/emis/event?project_id=' + e.layer.feature.properties.PRJ_ID + '&disa_no=' + e.layer.feature.properties.DISA_NO + '&type=' + e.layer.feature.properties.project_id_type;
			var this_event = ajax_call(url);
			var data_DM0302 = ajax_call(publicPath + '/napi/emis/treatment_condition?prj_id=' + this_marker.feature.properties.PRJ_ID + '&disa_no=' + this_marker.feature.properties.DISA_NO + '&type=' + e.layer.feature.properties.project_id_type);
			var data_DM0303 = ajax_call(publicPath + '/napi/emis/treatment_history?prj_id=' + this_marker.feature.properties.PRJ_ID + '&disa_no=' + this_marker.feature.properties.DISA_NO + '&type=' + e.layer.feature.properties.project_id_type);
			var data_DM0302_html = overall_case_status(data_DM0302, data_DM0303[(data_DM0303.length)-1]);
			var pic_data = ajax_call(publicPath + '/napi/emis/eventpic?prj_id=' + this_marker.feature.properties.PRJ_ID + "&disa_no=" + this_marker.feature.properties.DISA_NO);
			var pic_trig_dom = "";
			if (pic_data.length == 0) {
				pic_trig_dom = '<button type="button" class="btn btn-secondary btn-sm" id="case_pic_trig"><i class="far fa-images mr-2"></i>現場影像對照</button>'
			} else {
				pic_trig_dom = '<button type="button" class="btn btn-danger btn-sm" id="case_pic_trig"><i class="far fa-images mr-2"></i>現場影像對照</button>'
			}
			var report_from_source = this_event[0].DISA_FROM;
			if (report_from_source != "119轉入") { report_from_source = condition_who(report_from_source) };
			$('#event_div').html(
				'<h5 class="font-weight-bold">行政區：' + condition_area(this_event[0].TID) + '</h5>' +
				'<h6 class="float-right">案件編號：' + this_event[0].DISA_NO + '</h6>' +
				'<h6>通報時間：' + timeConverter(this_event[0].RPT_TIME)  + '</h6>' +
				'<h6>案件敘述：' + this_event[0].SITUATION + '</h6>' +
				'<h6>地址：' + this_event[0].DISA_LOCATION + '</h6>' +
				'<h6 class="float-right">處理狀態：' + condition_status_type(this_event[0].STATUS) + '</h6>' +
				'<h6>嚴重程度：' + condition_disa_level_component(this_event[0].DISA_LEVEL) + '</h6>' +
				'<h6>通報來源：' + report_from_source + '</h6>' +
				'<h6>災害類型：' + condition_disa_type(this_event[0].DISA_TYPE) + '</h6>' +
				'<div class="btn-group mb-5p" role="group">'+
					pic_trig_dom +
					'<button type="button" class="btn btn-warning btn-sm" id="case_timeline_trig"><i class="fas fa-forward mr-2"></i>案件處理歷程</button>'+
				'</div>'+
				'<div class="mt-1 mb-1 border-bottom"></div>'+
				data_DM0302_html
			);

			$("#case_pic_trig").on(trigger_method, function(){
				var pic_html_string = ""
				if (pic_data.length != 0) {
					var pic_key_name = ["UNFILENAME", "UNFILENAME2", "UNFILENAME3", "UNFILENAME4"]
					var pic_url_array = []
					pic_key_name.forEach(eachKey => {
						if (pic_data[0][eachKey]) {
							pic_url_array.push('https://eoc2.ntpc.gov.tw/Common//Load.ashx?p=' + pic_data[0]["PRJ_ID"] + '&d=' + pic_data[0]["DISA_NO"] + '&f=' + pic_data[0][eachKey])
						}
					})
					pic_html_string = event_pic_carousel(pic_url_array)
					pic_html_string =
						'<div class="col-6 text-center">'+
							'<h5>現場災情影像</h5>'+
							pic_html_string +
						'</div>'
				}
				pointCctvModalMap(
					'案件編號' + this_marker.feature.properties.DISA_NO + '多元災情影像',
					pic_html_string,
					this_marker,
					"limit"
				)
			})

			$("#case_timeline_trig").on(trigger_method, function(){
				var html_string = '',
					html_string_first = '',
					html_string_body = '',
					pic_key_name = ["FILENAME", "FILENAME1", "FILENAME2", "FILENAME3", "FILENAME4"]
				data_DM0302.forEach(function(element){
					html_string_first += '<i class="fas fa-circle text-'  + condition_DM0302_status_color(element.STATUS)[0] + '"></i>' + condition_who(element.DISP_DEPT) +　'：'　+　condition_DM0302_status(element.STATUS) + '&nbsp&nbsp&nbsp'
				});
				var title = '<li><div class="timeline-badge"><i class="fas fa-stopwatch"></i></div><div class="timeline-panel"><div class="timeline-heading"><h4 class="timeline-title font-weight-bold">案件開始受理</h4><p><small class="text-muted"><i class="far fa-clock"></i>' + timeConverter(this_event[0].RPT_TIME) + '</small></p></div><div class="timeline-body"><h5>' + html_string_first + '</h5></div></div></li>';
				data_DM0303.forEach(function(element){
					var pic_url_array = []
					pic_key_name.forEach(eachKey => {
						if (element[eachKey]) {
							try {
								var thisFileNameArray = element[eachKey].split(',')
								thisFileNameArray.forEach(eachPicName => {
									if (eachPicName !== "") {
										pic_url_array.push(`https://eoc2.ntpc.gov.tw/Common/DL.ashx?PRJ_ID=${element.PRJ_ID}&DISA_NO=${element.DISA_NO}&DISP_DEPT=${String(element.DISP_DEPT).slice(0,3)}&FILENAME=${eachPicName}`)
									}
								})
							} catch(e) {}
						}
					})
					if (pic_url_array.length === 0) {
						html_string_body = `<h5>${element.PROCESS}</h5>`
					} else {
						html_string_body = `
							<div class="row">
								<div class="col-4"><h5>${element.PROCESS}</h5></div>
								<div class="col-8">${event_pic_carousel(pic_url_array)}</div>
							</div>`
					}
					html_string += `
						<li>
							<div class="timeline-badge ${condition_DM0302_status_color(element.STATUS)[1]}"></div>
							<div class="timeline-panel">
								<div class="timeline-heading">
									<h4 class="timeline-title font-weight-bold">${condition_who(element.DISP_DEPT, element.REP_NAME)}</h4>
									<p>
										<small class="text-muted"><i class="far fa-clock"></i>${timeConverter(element.REP_TIME)}</small>
									</p>
								</div>
							<div class="timeline-body">
								${html_string_body}
							</div>
						</div>
					</li>`
				});
				modal_open('<div class="container"><ul class="timeline">' + title + html_string + '</ul></div>', '案件編號第' + this_event[0].DISA_NO + '筆-時序列處理回覆查看');
			});
		}, 1000);
	}

	function filter(feature, layer) {
		if (filter_condition["key"] == "DISA_TYPE") {
			if (filter_condition["value"][1] != null) {
				var ans = (condition_disa_type(feature.properties[filter_condition["key"]]) == filter_condition["value"][0] && condition_area(feature.properties["TID"]) == filter_condition["value"][1]);
			} else {
				var ans = condition_disa_type(feature.properties[filter_condition["key"]]) == filter_condition["value"][0];
			}
		} else {
			var ans = condition_area(feature.properties[filter_condition["key"]]) == filter_condition["value"];
		}

		if (filter_time != null) {
			var this_time = event_time_processing(feature.properties.RPT_TIME);
			if (this_time >= filter_time.min && this_time <= filter_time.max) {
				return ans;
			}
		} else {
			return ans;
		}
    }

    function filter_time_only(feature, layer) {
    	var this_time = event_time_processing(feature.properties.RPT_TIME);
		var ans = (this_time >= filter_time.min && this_time <= filter_time.max);
		return ans;
    }
	return result;
}

function overall_case_status(data, DM0303_last){
	var html_string = '';
	data.forEach(function(element){
		html_string += '<div class="col-6 p-1"><h6 class="m-0"><i class="fas fa-circle text-' + condition_DM0302_status_color(element.STATUS)[0] + '"></i>' + condition_who(element.DISP_DEPT) +　'：'　+　condition_DM0302_status(element.STATUS)　+　'</h6></div>'
	});
	if (DM0303_last != undefined) {
		html_string =
			'<h5 class="mb-0 font-weight-bold"><i class="far fa-address-card ml-2"></i>案件回覆概況</h5><div class="row pr-2 pl-2">' +
			'<div class="col-12 p-1"><h6 class="m-0">最新回覆(' + timeConverter(DM0303_last.REP_TIME) +')<i class="fas fa-angle-right ml-2"></i><br>' + condition_who(DM0303_last.DISP_DEPT, DM0303_last.REP_NAME) + "：" + DM0303_last.PROCESS + '</h6></div>' +
			html_string + '</div>';
	} else {
		html_string =
			'<h5 class="mb-0 font-weight-bold"><i class="far fa-address-card"></i>案件回覆概況</h5><div class="row pr-2 pl-2">' +
			'<div class="col-12 p-1"><h6 class="font-weight-bold">目前沒有單位回覆</div>' + html_string + '</div>';
	}
	return html_string;
}

function time_string(input){
	var value = String(input);
	if (value.length == 1) {
		value = "0" + value;
	}
	return value;
}

function createLabelIcon(labelClass,labelText){
    return L.divIcon({
        className: labelClass,
        html: labelText
    })
}

function getMaxOfArray(numArray) {
	return Math.max.apply(null, numArray);
}

function getMinOfArray(numArray) {
	return Math.min.apply(null, numArray);
}

// create event map
function create_event_map(data, map_type, filter_method = null){
	var event_marker_layer = event_marker(data, filter_method, null, map_type)
	if (overlay_dataset["重大災情"] != undefined || overlay_dataset["一般災情"] != undefined) {
		map.removeLayer(overlay_dataset["重大災情"]);
		map.removeLayer(overlay_dataset["一般災情"]);
	};
	overlay_dataset["重大災情"] = event_marker_layer[0];
	overlay_dataset["一般災情"] = event_marker_layer[1];
}

function create_flex_event(){
	var all_type = ajax_call(publicPath + "/napi/emis/search/emis_disaster_type");
	var all_event = ajax_call(publicPath + "/napi/emis/search/emis_events");
	var type_inut_string = "", event_input_string = "";
	all_type.forEach(function(element, index){
		type_inut_string += '<div class="form-check form-check-inline"> <input type="checkbox" class="form-check-input" id="' + element.DISA_TYPE_ID + '" value="' + element.DISA_TYPE_ID +'"><label class="form-check-label" for="' + element.DISA_TYPE_ID +'">' + element.DISA_TYPE_NAME + '</label></div>';
	});
	all_event.forEach(function(element){
		event_input_string +=
        	'<tr id="row_' + element.PRJ_ID +'">' +
            	'<td class="d-none"><div class="form-check form-check-inline"><input class="form-check-input" type="checkbox" value="' + element.PRJ_ID +'"><label class="form-check-label"></label></div></td>' +
                '<td>' + String(element.PRJ_ID).slice(0, 4) + '</td>' +
                '<td>' + element.DISA_KIND + '</td>' +
                '<td>' + element.PRJ_NAME + '</td>' +
            '</tr>'
	});
	modal_event_flex_open(
		'<div class="row">'+
			'<div class="col-5">'+
				'<h5 class="font-weight-bold"><i class="fas fa-tag"></i>災情事件選擇(單選)</h5>'+
                '<table id="all_event_list" width="100%">' +
                    '<thead>' +
                        '<tr>' +
                        	'<th class="d-none">>勾選</th>' +
                            '<th>年度</th>' +
                            '<th>種類</th>' +
                            '<th>名稱</th>' +
                        '</tr>' +
                    '</thead>' +
                    '<tbody>' +
                    	event_input_string +
                    '</tbody>'+
                '</table>'+
			'</div>'+
			'<div class="col-7">'+
				'<h5 class="font-weight-bold mt-0"><i class="fas fa-tags"></i>災情事件選擇(時間多選)</h5>'+
				'<div>'+
					'<div class="input-group mb-2 mt-2">'+
						'<div class="input-group-prepend">'+
							'<label class="input-group-text">起始時間</label>'+
						'</div>'+
						'<select class="custom-select" id="event_multi_select_start">'+
							'<option value="2019">2019年</option>'+
							'<option value="2018">2018年</option>'+
							'<option value="2017">2017年</option>'+
							'<option value="2016">2016年</option>'+
							'<option value="2015">2015年</option>'+
							'<option value="2014">2014年</option>'+
							'<option value="2013">2013年</option>'+
							'<option value="2012" selected>2012年</option>'+
						'</select>'+
					'</div>'+
					'<div class="input-group mb-2">'+
						'<div class="input-group-prepend">'+
							'<label class="input-group-text">結束時間</label>'+
						'</div>'+
						'<select class="custom-select" id="event_multi_select_end">'+
							'<option value="2019" selected>2019年</option>'+
							'<option value="2018">2018年</option>'+
							'<option value="2017">2017年</option>'+
							'<option value="2016">2016年</option>'+
							'<option value="2015">2015年</option>'+
							'<option value="2014">2014年</option>'+
							'<option value="2013">2013年</option>'+
							'<option value="2012">2012年</option>'+
						'</select>'+
					'</div>'+
					'<button type="button" class="btn btn-success btn-sm btn-block" id="event_multi_select_trig">符合條件事件列表建立</button>'+
				'</div>'+
				'<h5 class="font-weight-bold mt-3 mb-1"><i class="fas fa-chart-pie"></i>災情類型選擇</h5>'+
				'<div id="all_type_list">'+
					type_inut_string +
				'</div>'+
			'</div>'+
			'<div class="col-12 mt-3">'+
				'<h5 class="font-weight-bold mt-2 mb-2"><i class="fas fa-table"></i>已選擇清單列表</h5>'+
				'<div id="event_selected_list" class="h-150 overflow-auto-y"></div>'+
				'<button type="button" class="btn btn-success btn-block mt-3" id="flex_event_render">查詢並變換災情地圖</button>'+
			'</div>'+
		'</div>'
	);
	setTimeout(function(){
        $("#all_event_list").DataTable({
            "order": [[ 1, "desc" ]],
            "searching": true
        });

        $("#event_multi_select_trig").click(function(){
        	$("#event_selected_list").html("");
        	var start_year = parseInt($("#event_multi_select_start").val());
        	var end_year = parseInt($("#event_multi_select_end").val());
        	var selected_tag_string = "";
        	all_event.forEach(function(element){
        		if (parseInt(element.PRJ_ID.slice(0, 4)) >= start_year && parseInt(element.PRJ_ID.slice(0, 4)) <= end_year) {
					$("#event_selected_list").append('<span class="selected-tag" id="selected_tag_' + element.PRJ_ID +'" value="' + element.PRJ_ID +'">#' + element.PRJ_NAME + '<button type="button" class="btn btn-link p-0 ml-1">X</button><span>');
					$("#selected_tag_" + element.PRJ_ID + " button").click(function(){
						$(this).parent("span").remove();
					});
        		}
        	});
        });

		$('#all_event_list tbody').on('click', 'tr', function(){
			var boolean = $("#selected_tag_" + $(this).find('input').val()).length;
			if (boolean == 0){
				$("#event_selected_list").append('<span class="selected-tag" id="selected_tag_' + $(this).find('input').val() +'" value="' + $(this).find('input').val() +'">#' + $(this).find('td').eq(3).html() + '<button type="button" class="btn btn-link p-0 ml-1">X</button><span>');
				$("#selected_tag_" + $(this).find('input').val() + " button").click(function(){
					$(this).parent("span").remove();
				});
			} else {
				$("#selected_tag_" + $(this).find('input').val()).remove();
			}
	    });

        $("#flex_event_render").click(function(){
        	$('#event_flex_modal').modal('hide');
        	loader_asynchronous(function(){
	        	var event_list = [], type_list = [];
	        	$(".selected-tag").each(function(){
	        		event_list.push($(this).attr("value"));
	        	});
	        	$("#all_type_list input").each(function(){
	        		var boolean = $(this).prop("checked");
	        		if (boolean) {
	        			type_list.push($(this).attr("value"));
	        		}
	        	});
	        	if (type_list.length == 0) {
	        		type_list = "no";
	        	};
	        	if (event_list.length == 0) {
	        		event_list = "no";
	        	};

	        	if($("#event_update_controler").prop("checked")){
	        		$("#event_update_controler").click();
	        	};
		        var query_data = ajax_call_post(publicPath + "/napi/emis/search/emis_flex_events", {
					dataset: {
						event_id: event_list,
						disaster_type_id: type_list
					}
				});
				raw_data["event_flex"] = event_raw_geojson(query_data, null);
				var type = $("#event_plot_div .active").find("input").val();
				create_event_map(raw_data["event_flex"], type);
				$("#event_plot_div .btn-secondary").unbind();
				$("#event_plot_div .btn-secondary").click(function(){
					var type = $(this).find("input").val();
					loader_asynchronous(function(){
						create_event_map(raw_data["event_flex"], type);
					});
				});
			});
        });
	}, 1000);
}

function flood_hotspot(){
	var result,
		data = ajax_call("geojson/flood_hotspot/point.json"),
		thisIcon = {
			iconUrl: 'marker_icon/flood_hotspot.png',
			iconAnchor:   [16, 32],
			iconSize:     [32, 32],
			popupAnchor:  [0, -20]
		}
	result = L.geoJSON(data,{
      	pointToLayer: function(feature, latlng) {
        	return L.marker(latlng, {
          		icon: new L.icon(thisIcon)
        	}).bindPopup('<div id="other_area" class="w-300">資料連結中...</div>');
      	}
    }).on('click', function(e){
		var this_marker = e.layer.feature.properties
		setTimeout(function(){
			$('#other_area').html(
				'<h5 class="font-weight-bold">易淹水通報點位</h5>' +
				'<h6>行政區：' + this_marker.region + '</h6>' +
				'<h6>地址：' + this_marker.location + '</h6>' +
				'<h6>通報日期：' + this_marker.time + '</h6>' +
				'<h6>淹水範圍：' + null_Converter_v2(this_marker.flood_area) + '</h6>' +
				'<h6>易致災說明：' + this_marker.description + '</h6>' +
				'<button type="button" class="btn btn-danger btn-sm" id="point_cctv_trig"><i class="far fa-images mr-2"></i>現場影像調閱</button>'
			)
			var trigger_method;
			isiOS ? ( (trigger_method = "mouseover") ) : ( (trigger_method = "click"));
			$("#point_cctv_trig").on(trigger_method, function(){
				pointCctvModalMap('<h5 class="font-weight-bold">易淹水熱點(' + this_marker.location + ')鄰近CCTV影像查看</h5>', "", e.layer, "limit")
			})
		}, 1000)
	})
	return result;
}

function pointCctvModalMap(title, other_html, this_marker, type){
	var html_string =
		'<div class="row">'+
			'<div class="col-6 text-center mb-3">'+
				'<h5>Google街景影像</h5>'+
				'<div id="panorama_container" class="h-350"></div>'+
			'</div>'+
			other_html +
			'<div class="col-6 text-center mb-0">'+
				'<h5>鄰近此災情的CCTV地圖</h5>'+
				'<div class="w-100 h-400" id="modal_map"></div>'+
			'</div>'+
			'<div id="cctv_iframe" class="col-6 text-center mt-3 mb-0"></div>'+
		'</div>'
	modal_open(html_string, title);
	setTimeout(function(){
		var panorama = new google.maps.StreetViewPanorama(
			document.getElementById('panorama_container'), {
				position: {
					lat: parseFloat(this_marker.feature.geometry.coordinates[1]),
					lng: parseFloat(this_marker.feature.geometry.coordinates[0])
				},
				pov: { heading: 165, pitch: 0 }
			})
		var modal_map = new L.Map('modal_map', {
			attributionControl: false,
			zoomControl: false,
			center: new L.LatLng(this_marker.feature.geometry.coordinates[1], this_marker.feature.geometry.coordinates[0]),
			zoom: 18,
			zoomSnap: 1,
			layers: L.tileLayer('https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',{
				maxZoom: 22,
				subdomains:['mt0','mt1','mt2','mt3'],
				opacity: 0.8
			})
		})
		var this_popup = L.popup({ closeOnClick: false }).setContent('<div class="text-center w-200">此災情位置<br>請點擊鄰近CCTV點位查看影像</div>'),
			this_event = L.marker([this_marker.feature.geometry.coordinates[1], this_marker.feature.geometry.coordinates[0]]).addTo(modal_map).bindPopup(this_popup).openPopup(),
			normalCctvLayer = [cctv_wra()[0], cctv_tv()[0], cctv_traffic()[0], cctv_thb()[0], cctv_freeway()[0], cctv_wrs_hrcm()[0], cctv_swcb()[0], cctv_underpass()[0]] // cctv_wrs()[0],
		normalCctvLayer.forEach(function(eachLayer){
			eachLayer.addTo(modal_map)
		})
		switch (type) {
			case "normal":
				if (user_unit_name === "新北市政府消防局資通管考科" || user_unit_name === "新北市政府消防局整備應變科" || user_unit_name === "新北市政府消防局減災規劃科" || user_unit_name === "資訊委外廠商新北市政府消防局") {
					var cctv_police_layer = cctv_police(modal_map)[0].addTo(modal_map)
				}
				break
			case "limit":
				var layerIcon = {
					iconUrl: 'marker_icon/cctv_police.png',
					iconAnchor:   [15, 32],
					iconSize:     [32, 32],
					popupAnchor:  [0, -20]
				}
				ajax_call_async(publicPath + "/cloud/geoserver/edp2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=edp2%3Apolice_cctv&maxFeatures=50&cql_filter=DWITHIN(geom,MULTIPOINT((" + this_marker.feature.geometry.coordinates[0] + "%20" + this_marker.feature.geometry.coordinates[1] + ")),250,meters)&outputFormat=application%2Fjson", function(res){
					L.geoJSON(res, {
						pointToLayer: function(feature, latlng) {
							return L.marker(latlng, {
								icon: new L.icon(layerIcon)
							})
						  }
					}).addTo(modal_map).on("click", function(e){
						var marker = e.layer.feature.properties
						cctv_modal(
							"警察局-" + marker.name,
							publicPath + "/napi/police/hlshtml/" + marker.id + "?jwt=" + localStorage.getItem('jwt_token'),
							"iframe",
							true
						)
					})
				})
				break
		}
	}, 1000)
}

function event_pic_carousel(pic_array){
	var carousel_html_string = "",
		carousel_id = createRandomId(5)
	pic_array.forEach((url, index) => {
		if (index === 0) {
			carousel_html_string += `
				<div class="carousel-item active">
					<img class="d-block w-100 h-400" src="${url}" alt="案件照片">
				</div>`
		} else {
			carousel_html_string += `
				<div class="carousel-item">
					<img class="d-block w-100 h-400" src="${url}" alt="案件照片">
				</div>`
		}
	})
	carousel_html_string =
		`<div id="modal_carousel_${carousel_id}" class="carousel slide" data-ride="carousel">
			<div class="carousel-inner">
				${carousel_html_string}
			</div>
			<a class="carousel-control-prev" href="#modal_carousel_${carousel_id}" role="button" data-slide="prev">
				<span class="carousel-control-prev-icon" aria-hidden="true"></span>
				<span class="sr-only">Previous</span>
			</a>
			<a class="carousel-control-next" href="#modal_carousel_${carousel_id}" role="button" data-slide="next">
				<span class="carousel-control-next-icon" aria-hidden="true"></span>
				<span class="sr-only">Next</span>
			</a>
		</div>`;
	return carousel_html_string
}
